import { QuestionTypes } from '@showbie-socrative/socrative-utils';
import { translate } from '~l10n/client';
import { useAtom } from 'jotai';

import { toast } from '~shared/components/Toast';
import { handleAiRateLimitError } from '~teacher/components/QuizEditor/errorHandlers/aiRateLimitErrorHandler';
import {
  generateQuestionAtom,
  promptAtom,
} from '~teacher/components/QuizEditor/GenerateQuestionDialog/atom';

import { useQuestionGenerator } from './context';
import { checkIsPromptEmpty, checkIsQuestionTypeEmpty } from './utils';

export function useHandleGenerateQuestions() {
  const questionGenerator = useQuestionGenerator();

  const [
    {
      [QuestionTypes.MultipleChoice]: multipleChoice,
      [QuestionTypes.TrueFalse]: trueFalse,
      [QuestionTypes.FreeResponse]: shortAnswers,
      questionCount,
      includeExplanation,
    },
  ] = useAtom(generateQuestionAtom);
  const [prompt] = useAtom(promptAtom);

  return () => {
    if (
      checkIsQuestionTypeEmpty({
        multipleChoice: multipleChoice,
        trueFalse: trueFalse,
        shortAnswers: shortAnswers,
      }) ||
      checkIsPromptEmpty(prompt)
    ) {
      toast.critical(translate('Required field(s) missing'));
      return;
    }

    questionGenerator.mutate(
      {
        questionCount: questionCount,
        topic: prompt,
        includeExplanation: includeExplanation,
        questionTypes: [
          ...(multipleChoice ? ['MultipleChoice' as const] : []),
          ...(trueFalse ? ['TrueFalse' as const] : []),
          ...(shortAnswers ? ['FreeResponse' as const] : []),
        ],
      },
      {
        onError: handleAiRateLimitError,
      }
    );
  };
}
